module.exports = __webpack_public_path__ + "img/dashboard.4835f726.svg";